import { PRESET_AUD_TEST, PRESETS } from '@/components/Deposit/helpers';
import { CurrencyCode } from '@/helpers/currency';
import { useIsExpReducedPresetAUDLU } from '@/hooks/useIsExpReducedPresetAUDLU';
import { useCommonStore } from '@/store';

export const usePresets = () => {
  const user = useCommonStore.use.user();
  const isExpReducedPresetAUDLU = useIsExpReducedPresetAUDLU();

  if (isExpReducedPresetAUDLU) {
    return PRESET_AUD_TEST[CurrencyCode.AUD];
  }
  if (user?.currency) {
    return PRESETS[user.currency];
  }
  return [];
};
